<!--suppress CssUnusedSymbol -->
<script setup lang="ts">
import DialogWrapper from "@/shared/components/ui/dialog/DialogWrapper.vue";
import {Toaster} from "@/shared/components/ui/sonner";
import AlertDialogWrapper from "@/shared/components/ui/alert-dialog/AlertDialogWrapper.vue";
import {useCheckoutStore} from "@/checkout/stores/checkout.store.ts";
import {computed, onBeforeUnmount, onMounted, watch} from "vue";
import {faHourglassEnd} from "@fortawesome/pro-regular-svg-icons";
import Loader from "@/shared/components/ui/loader/Loader.vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";
import {faBomb} from "@fortawesome/pro-solid-svg-icons";
import CheckoutError from "@/checkout/components/CheckoutError.vue";
import {Color} from "@/shared/graphql/types";
import {setupSystemSubscription, unsubscribeSystemSubscription} from "@/shared/composable/system.subscription.ts";

const {t} = useI18n()

const route = useRoute();
const checkout = useCheckoutStore();

setupSystemSubscription();

const isTester = computed(() => route.name?.toString()?.startsWith("test") ?? false);
const isExpired = computed(() => checkout.expired);
const primaryColor = computed(() => {
  return checkout.app?.colorScheme?.colors?.find((color: Color) => color.name == "primary")?.hsl?.replace(/,/g, '')
});

onMounted(() => {
  // Set the initial value when the component is mounted
  if (primaryColor.value) document.body.style.setProperty('--primary', primaryColor.value);
  // Watch the primaryColor for changes
  watch(primaryColor, (newColor) => {
    document.body.style.setProperty('--primary', newColor);
  });
});

onBeforeUnmount(() => {
  try {
    unsubscribeSystemSubscription()
  } catch (e) {
    console.error(e)
  }
})
</script>

<template>
  <router-view v-if="isTester"/>
  <template v-else>
    <template v-if="isExpired">
      <CheckoutError :title="t('checkout.expired_title')"
                     :description="t('checkout.expired', { url: checkout.config.basketReturn.url})"
                     :icon="faHourglassEnd"/>
    </template>
    <template v-else-if="checkout.serverError">
      <CheckoutError :title="t('checkout.error_title')" :description="t('checkout.error_description') " :icon="faBomb"/>
    </template>
    <router-view v-else/>
    <Toaster position="bottom-right" :visibleToasts="5"/>
    <AlertDialogWrapper/>
    <DialogWrapper/>
    <div v-if="checkout.busy || checkout.loading" class="fixed inset-0 bg-white bg-opacity-60 flex items-center justify-center z-50">
      <Loader>
        <template v-if="checkout.loading">{{ t('shared.common.loading') }}</template>
        <template v-else>{{ t('shared.common.busy') }}</template>
      </Loader>
    </div>
  </template>
</template>

<style scoped>

</style>

